'use client'

import { memo, useMemo } from 'react'
import { IconCircleArrowRightFilled } from '@tabler/icons-react'
import Link from 'next/link'

import { ProductTypes, Promotion } from 'modules/products'
import { SeoListName } from 'shared/analytics'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import SpecialPromotionItem from './SpecialPromotionItem'

import styles from './SpecialPromotionItems.module.scss'

const SpecialPromotionItems = memo(
  ({
    promotion,
    products,
    listName,
    seoButtonPlace
  }: {
    promotion: Promotion
    products: ProductTypes[] | null
    listName: SeoListName
    seoButtonPlace: string
  }) => {
    const filteredProducts = useMemo(() => {
      return (
        products?.filter(
          product => product?.promotions?.[0]?.id === promotion.id
        ) || []
      )
    }, [products, promotion.id])

    return (
      <div className={styles.container}>
        <>
          {isNotNilOrEmpty(filteredProducts) ? (
            <>
              <h6 className={styles.label}>
                {filteredProducts.length > 1
                  ? 'Produkty które należy dodać aby skorzystać z promocji:'
                  : 'Produkt który należy dodać aby skorzystać z promocji:'}
              </h6>
              <div className={styles.wrapper}>
                {filteredProducts.map(product => (
                  <SpecialPromotionItem
                    key={product.id}
                    product={product}
                    seoButtonPlace={seoButtonPlace}
                    idxOnList={0}
                    listName={listName}
                  />
                ))}
                {(isNotNilOrEmpty(promotion.productCategorySlug) ||
                  isNotNilOrEmpty(promotion.brandSlug)) && (
                  <div>
                    <Link className={styles.redirectTile}
                      href={
                        promotion.productCategorySlug ??
                        promotion.brandSlug ??
                        ''
                      }
                    >
                      Zobacz wszystkie produkty promocyjne:
                      <IconCircleArrowRightFilled size={60} />
                    </Link>
                  </div>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    )
  }
)

export default SpecialPromotionItems
